// extracted by mini-css-extract-plugin
export default {"overlay":"ModalTemplate_overlay__Xgzjh","content":"ModalTemplate_content__sfP0M"};